import React from 'react'
import { Stack, Box, Typography, Button } from '@mui/material'
import EditIcon from '@mui/icons-material/EditOutlined'
import bangaloreZoneImage from '../assets/images/maps/bangalore-zone.png'
import bagalakoteZoneImage from '../assets/images/maps/bagalkote-zone.png'
import mysoreZoneImage from '../assets/images/maps/mysore-zone.png'
import kalaburgiZoneImage from '../assets/images/maps/kalaburgi-zone.png'
import tumakuruZoneImage from '../assets/images/maps/tumakuru-zone.png'
import mangaloreZoneImage from '../assets/images/maps/mangalore-zone.png'
import { useNavigate } from 'react-router'

const ZoneInformation = ({ selectedZone }) => {
  const navigate = useNavigate()

  const zoneMapping = {
    Kalaburgi: kalaburgiZoneImage,
    Bagalakote: bagalakoteZoneImage,
    Mysore: mysoreZoneImage,
    Tumakuru: tumakuruZoneImage,
    Mangalore: mangaloreZoneImage,
    Bangalore: bangaloreZoneImage
  }
  const representativesPoints = [
    'Zone wise Members Strength in Each Cadre.',
    'Cadre Strength Representation in CEC as per KEBEA by-law.'
  ]
  const advantagesPoints = [
    'Equal Representation Across Karnataka From all the zones and Cadres.',
    '⁠Developing Responsible Local Leadership.',
    'Decentralisation of Administration.',
    'Transparency in selecting CEC members',
    'Fair selection of interested, enthusiastic candidates without bias.'
  ]
  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', mb: 2 }}>
        <Typography variant='med_28_500'>
          Selected Zone : {selectedZone}
        </Typography>
        <Button
          variant='text'
          onClick={() => navigate(-1)}
          endIcon={<EditIcon />}
          sx={{ textTransform: 'none', ml: 2, fontSize: '20px', fontWeight: 600 }}
        >
          Edit
        </Button>
      </Box>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mt: 3, alignItems: 'center' }}>
        <img src={zoneMapping[selectedZone]} alt='Zone Information' style={{ width: '100%', height: '50vh', objectFit: 'contain', minWidth: '40%' }} />
        <Box sx={{ minWidth: '60%', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
          <Box>
            <Typography variant='h6' sx={{ my: 1, color: 'primary.main', fontWeight: 'bold' }}>
              No of Representatives from Each Cadre depends on
            </Typography>
            {representativesPoints.map((text, index) => (
              <Box key={index} display='flex' alignItems='flex-start'>
                <Typography
                  variant='body1'
                  sx={{
                    minWidth: '24px'
                  }}
                >
                  {index + 1}.
                </Typography>
                <Typography variant='body1'>{text}</Typography>
              </Box>
            ))}

            <Typography variant='h6' sx={{ my: 1, color: 'primary.main', fontWeight: 'bold', mt: 4 }}>
              Advantages
            </Typography>
            {advantagesPoints.map((text, index) => (
              <Box key={index} display='flex' alignItems='flex-start'>
                <Typography
                  variant='body1'
                  sx={{
                    minWidth: '24px'
                  }}
                >
                  {index + 1}.
                </Typography>
                <Typography variant='body1'>{text}</Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Stack>
    </>
  )
}

export default ZoneInformation
